import { useAppQuery } from '@/hooks/useAppQuery';
import { api } from '@/lib/api-client';
import { type LifecycleState } from '@/models/lifecycleState';

import { seasonPassQueryKey } from './queryKeys';
import { type ListSeasonPassesResponse } from '../models/seasonPass';

export const SEASON_PASSES_LIMIT = 25;

export interface GetSeasonPassesParams {
  game_code?: string;
  sandbox_code?: string;
  state?: LifecycleState;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  limit: number;
  offset: number;
}

export const getSeasonPasses = async ({
  game_code,
  sandbox_code,
  state,
  sort_by = 'created_at',
  sort_order = 'desc',
  limit,
  offset,
}: GetSeasonPassesParams): Promise<ListSeasonPassesResponse> => {
  const params = new URLSearchParams({
    sort_by,
    sort_order,
    limit: limit.toString(),
    offset: offset.toString(),
  });
  if (game_code) params.append('game_code', game_code);
  if (sandbox_code) params.append('sandbox_code', sandbox_code);
  if (state) params.append('state', state);

  const response = await api.get<ListSeasonPassesResponse>(
    `/v1/season-passes?${params.toString()}`,
  );
  return response.data;
};

export const seasonPassesQuery = (params: GetSeasonPassesParams) => ({
  queryKey: seasonPassQueryKey.list(params),
  queryFn: () => getSeasonPasses(params),
});

export const useSeasonPasses = (params: GetSeasonPassesParams) =>
  useAppQuery(seasonPassesQuery(params));
